<template>
    <div>
        <div class="wrapper-all">
            <div class="wrapper">
                <div>
                    <!-- <h5 style="margin-bottom: 25px">
                    Select your preferred language
                </h5> -->
                    <b-form style="margin-bottom: 15px">
                        <b-form-group
                            id="input-group-1"
                            label="Select your preferred language"
                            label-for="language-option"
                            
                            class="
                                
                                kyc-status-radio
                                overwrite-radio
                            "
                        >
                            <b-form-radio-group
                                id="language-option"
                                v-model="languageOption"
                                v-validate="{
                                    required: true,
                                }"
                                :options="options"
                                name="language option"
                                :class="{
                                    'is-invalid': errors.has('language option'),
                                }"
                                class=""
                                @input="setLanguageOption"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-form>

                    <div class="row">
                        <div class="col-12">
                            <div class="row justify-content-center">
                                <base-button
                                    btn-type="submit"
                                    btn-variant="primary"
                                    btn-label="CONTINUE"
                                    :class="loading ? 'disabled' : ''"
                                    :disabled="loading"
                                    @onClickButton="onClick"
                                >
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="CONTINUE"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                        @onClickButton="onClick"
                    >
                    </base-button>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import request from '@/utils/request'
import Radio from '@/components/registration/Radio.vue'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        PopupButton,
        Radio,
    },

    props: {
        data: { type: String },
    },

    data() {
        return {
            languageOption: null,
            options: [
                {
                    text: 'English',
                    value: 'en',
                },
                {
                    text: 'Urdu',
                    value: 'urd',
                },
            ],
        }
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    },
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */

    mounted() {},
    methods: {
        onClick() {
            this.$emit('agreed')
        },
        setLanguageOption() {
            this.$store.commit('updateField', {
                key: 'languageOption',
                value: this.languageOption,
            })
            
        },
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}
.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
</style>
